import { StoreState } from 'app/app.reducers';

export const getInstituteOffers = (state: StoreState) => state.institute.offers;

export const getCurrentInstituteOfferPage = (state: StoreState) => state.institute.currentOfferPage;
